module.exports = __webpack_public_path__ + "img/noise.3894d45.png";